import axios from 'axios';
import qs from 'qs';
import { store } from '../..';
import { sessionExpiredTrue } from '../../redux/auth';
import { LOCAL_STORAGE_TOKEN } from '../http/auth';
import { API_BASE_URL } from '../http';

class DynamicAPI {
  constructor(apiVersion = 'v2') {
    this.http = axios.create({
      baseURL: `${API_BASE_URL}/${apiVersion}`,
      headers: {
        authorization: `Bearer ${localStorage.getItem(LOCAL_STORAGE_TOKEN)}`,
      },
    });

    this.http.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const { status } = error.response;

        if (status === 401) {
          store.dispatch(sessionExpiredTrue());
          return Promise.reject(error); 
        }

        return Promise.reject(error);
      }
    );
  }

  async get(endpoint, queryParams) {
    const result = await this.http.get(endpoint, {
      params: queryParams,
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: 'comma' }),
    });

    return result.data;
  }

  async post(endpoint, body) {
    const result = await this.http.post(endpoint, body);
    return result.data;
  }
}

export default DynamicAPI;
